import {React , useState , useEffect} from 'react'
import { getAllDevelopers } from '../../services/Api';
import DeveloperCard from "../../components/DevelopersCard/DevelopersCard.js"
import "./Developers.css"

const Developers = () => {
  
  const initial = {
    uid: "",
    username: "",
    email: "",
    avatar_url: "",
    profile_links: "",
    work_month: "",
    word_year: ""
  };
  
  const [dev , setDev] = useState([]);
  
  useEffect(() => {
  
    const getDevelopers = async () => {
        try {
            const data = await getAllDevelopers();
            console.log(data?.data);
            if(data?.data)
                setDev(data?.data);
        } catch (error) {
            console.log(error);
        }
    }
    getDevelopers();
  }, [])
  
  
  return (
    <div className="dev-container">
        <div className="heading">
            Developers
        </div>
        <div className="text">
            This website is created by:
        </div>
        <div className="developers">
            {
                dev?.map((elem) => (
                    <DeveloperCard props={elem}/>
                ))
            }
        </div>
    </div>
  )
}

export default Developers